import {Item} from '../../generated/types';
import {ItemTypeNames} from './item-type-names';

export function getItemBaseType(item: Item) {
	const type = item.type && ItemTypeNames[item.type];
	return item.wondrous ? 'Чудесный предмет' : type?.title ? type.title : null;
}
